import { render, staticRenderFns } from "./QuotePanels.vue?vue&type=template&id=a5b83954"
import script from "./QuotePanels.vue?vue&type=script&lang=ts"
export * from "./QuotePanels.vue?vue&type=script&lang=ts"
import style0 from "./QuotePanels.vue?vue&type=style&index=0&id=a5b83954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports